import React from "react"
import clsx from "clsx"

import classes from "./Spinner.module.scss"

const Spinner = (props) => {
  const {
    className,
    size = 20,
    color = "black",
    ...otherProps
  } = props

  return (
    <div
      style={{
        borderColor: color,
        borderWidth: "3px",
        borderTopColor: "transparent",
        height: `${size}px`,
        width: `${size}px`
      }}
      className={clsx(classes["spinner"], className)}
      {...otherProps}
    />
  )
}

export default Spinner